import { useDailySunlightStore } from '@/store/dailySunlightsStore';
import styles from './styles.module.scss';
import { GridPointData } from './GridPointData';
import { DetailedGridPointData } from './DetailedGridPointData';
import { useEffect, useState, useCallback } from 'react';

export const SunlightTooltip = () => {
	const hoveredGridPointData = useDailySunlightStore((state) => state.hoveredGridPointData);
	const detailedGridPointsData = useDailySunlightStore((state) => state.detailedGridPointsData);
	const sunlightTabIndex = useDailySunlightStore((state) => state.sunlightTabIndex);
	const setSunlightTabIndex = useDailySunlightStore((state) => state.setSunlightTabIndex);
	const [tabIndex, setTabIndex] = useState(sunlightTabIndex);

	const handleKeyDown = useCallback((event: KeyboardEvent) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setTabIndex((prev) => {
				const newIndex = prev === 0 ? 1 : 0;
				setSunlightTabIndex(newIndex);
				return newIndex;
			});
		}
		if (event.key === '1') {
			setTabIndex(0);
			setSunlightTabIndex(0);
		}
		if (event.key === '2') {
			setTabIndex(1);
			setSunlightTabIndex(1);
		}
	}, [setSunlightTabIndex]);

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleKeyDown]);

	// Sync with store when sunlightTabIndex changes externally
	useEffect(() => {
		setTabIndex(sunlightTabIndex);
	}, [sunlightTabIndex]);

	// Auto-switch to tab 1 only if no hovered point but we have detailed data
	if (!hoveredGridPointData && detailedGridPointsData.length > 0 && tabIndex === 0) {
		setTabIndex(1);
		setSunlightTabIndex(1);
	}

	// Auto-switch to tab 0 if detailed data disappears
	if (tabIndex === 1 && detailedGridPointsData.length === 0) {
		setTabIndex(0);
		setSunlightTabIndex(0);
	}

	if (!hoveredGridPointData && detailedGridPointsData.length === 0) return null;

	return (
		<div className={styles.tooltip}>
			{detailedGridPointsData.length > 0 && (
				<div className={styles.tabBar}>
					<kbd className={tabIndex === 0 ? styles.active : ''}>1</kbd>
					<kbd className={tabIndex === 1 ? styles.active : ''}>2</kbd>
					<span className={styles.tabHint}>Tab/1/2 to switch views</span>
				</div>
			)}
			<div className={styles.helpText}>
				<span className={styles.helpLabel}>Tip:</span> Right-click in a room to add a sunlight score
			</div>
			{tabIndex === 0 && hoveredGridPointData && <GridPointData data={hoveredGridPointData} />}
			{tabIndex === 1 && <DetailedGridPointData data={detailedGridPointsData} />}
		</div>
	);
};
